import type { TFunction } from 'i18next'
import type { AuditMessage } from '@/services/shared/auditHistoryApi'

/**
 * The API sends an unset value as an empty string or the literal `"null"`, both
 * of which read badly inside "changed from {{previous}} to {{current}}", so
 * they become a dash.
 */
export function displayParameters(parameters: Record<string, string>): Record<string, string> {
  return Object.fromEntries(
    Object.entries(parameters).map(([key, value]) => [
      key,
      value === '' || value === 'null' ? '—' : value,
    ])
  )
}

/**
 * One audit message as a sentence. Each message carries a `code` and an English
 * `text` template, so it is translated by code where a translation exists and
 * falls back to the text the backend shipped where it does not.
 */
export function auditMessageText(t: TFunction, message: AuditMessage): string {
  return t(message.code, { defaultValue: message.text, ...displayParameters(message.parameters) })
}
